import React, { ForwardedRef } from "react";
import {
  SimpleTreeView,
  SimpleTreeViewProps,
} from "@mui/x-tree-view/SimpleTreeView";
import {
  TreeItem as MuiTreeItem,
  TreeItemProps,
} from "@mui/x-tree-view/TreeItem";

import theme from "theme";

interface ITreeItem extends TreeItemProps {
  dataTestid?: string;
}

export const TreeItem = React.forwardRef(
  (
    { dataTestid, ...rest }: ITreeItem,
    ref: ForwardedRef<HTMLLIElement> | null
  ) => <MuiTreeItem data-testid={dataTestid} {...rest} ref={ref} />
);

const TreeView = (props: SimpleTreeViewProps<boolean>) => (
  <SimpleTreeView
    sx={{
      "& .MuiTreeItem-content": {
        borderRadius: theme.spacing(0.5),
      },
      ...props.sx,
    }}
    {...props}
  />
);

export default TreeView;
